import React from 'react';
import { Fab, Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../../logo512.png';
import { useAuth } from '../../../hooks/useAuth';

export default function HomeFab({disabled = false}) {

  const navigate = useNavigate();
  const location = useLocation();
  const { role } = useAuth();

  if (location.pathname === '/dashboard' || disabled) {
    return null;
  }

  const handleClick = () => {
    navigate('/dashboard'); // redirect to /dashboard
  };

  return (
    <>
    {role !== 'guest' ?
    <Fab
      onClick={handleClick}
      color="primary"
      aria-label="add"
      sx={{
        position: 'fixed',
        bottom: -10,
        left: '50%', 
        transform: 'translateX(-50%)', 
        zIndex: 10000,
        opacity: 1,
        width: 52, 
        height: 52,
        minHeight: 52
      }}
    >
      {/* <HomeIcon fontSize='large' /> */}
      <Box
        component="img"
        src={logo}
        alt="Home"
        sx={{
          width: 48,
          height: 48,
          objectFit: 'contain',
        }}
      />
    </Fab>
    : null }
    </>
  );
}
